import { useMemo } from 'react';
import { DataSource } from '@weave/schema-gen-ts/dist/schemas/syncapp/integrations-service/datasource.pb';
import { SchemaIntegrationsService } from '@frontend/schema';
import { useAppScopeStore, useScopedQuery } from '@frontend/scope';

// This is how it should work, but it is not returning the data source id :angry: - have to do a workaround
// export const useAllIntegrationDetailsQuery = () => {
//   const { data, isError, isLoading, refetch } = useScopedQuery({
//     queryKey: ['all-integration-details'],
//     queryFn: () => SchemaIntegrationsService.ListIntegrations({}),
//   });

export const useAllIntegrationDetailsQuery = () => {
  const { selectedLocationIds, selectedGroupId } = useAppScopeStore();
  const { data, isError, isLoading, isSuccess } = useScopedQuery({
    queryKey: ['all-integration-details', ...selectedLocationIds, selectedGroupId],
    queryFn: () =>
      Promise.all(
        [...selectedLocationIds, selectedGroupId].map((locationId) =>
          SchemaIntegrationsService.ListDataSourcesByLocationID({ locationId })
        )
      ).then((results) => {
        const integrationsById: Record<string, DataSource> = {};
        results.forEach((result) => {
          result.dataSources?.forEach((datasource) => {
            if (datasource?.sourceId) {
              integrationsById[datasource?.sourceId] = datasource;
            }
          });
        });
        // Return just the unique set of integrations
        return integrationsById;
      }),
  });
  const getIntegrationDetails = useMemo(() => {
    return (integrationId?: string) => {
      if (!integrationId || isLoading || isError || !data) {
        return null;
      }
      return data[integrationId];
    };
  }, [data, isLoading, isError, selectedLocationIds, selectedGroupId]);

  const getAllDataSourceIds = useMemo(() => {
    return () => {
      if (isLoading || isError || !data) {
        return null;
      }

      return Object.keys(data);
    };
  }, [data, isLoading, isError, selectedLocationIds, selectedGroupId]);

  return { getIntegrationDetails, getAllDataSourceIds, isSuccess, isLoading, isError };
};
